'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PromisesResolver;
function PromisesResolver(AdminDescription) {
    return AdminDescription.getPromisesResolver();
}

PromisesResolver.$inject = ['AdminDescription'];
module.exports = exports['default'];
//# sourceMappingURL=PromisesResolver.js.map


// WEBPACK FOOTER //
// ./~/ng-admin/lib/javascripts/ng-admin/Crud/misc/PromisesResolver.js